import { api } from '../index';

export const getCollections = userData => api.get(`/report/${userData}`);

export const send = (queryUrl, data) => api.post(`/report/${queryUrl}`, data);
